const MESSAGES = {
    ERROR: {
        MSG_0001: '有効な郵便番号を入力してください。',
        MSG_0002: '※ご入力いただいた郵便番号は回収対象エリア外です。',
        MSG_0003: '都道府県市区町村を選択してください。',
        MSG_0004: '番地を入力してください。',
        MSG_0005: '回収希望日を選択してください。',
        MSG_0006: '回収希望時間帯を選択してください。',
        MSG_0007: 'お名前を入力してください。',
        MSG_0008: 'お名前に不正な文字が入力されています。',
        MSG_0009: 'お名前（カナ）を入力してください。',
        MSG_0010: 'お名前（カナ）は全角カナのみで入力してください。',
        MSG_0011: '携帯電話番号を入力してください。',
        MSG_0012: '携帯電話番号は半角数字10-11桁で入力してください。',
        MSG_0013: 'ご自宅電話番号は半角数字10-11桁で入力してください。',
        MSG_0014: 'メールアドレスを入力してください。',
        MSG_0015: 'メールアドレス形式で入力してください。',
        MSG_0016: '生年月日を入力してください。',
        MSG_0017: '有効な日付を入力してください。',
        MSG_0018: '性別を選択してください。',
        MSG_0019: 'メーカーを選択してください。',
        MSG_0020: '大きさを選択してください。',
        MSG_0021: 'ご入力いただいた郵便番号に該当する住所はございません。',
        MSG_0022: 'サービス対象外地域のため選択できません。',
        MSG_0023: '番地に不正な文字が入力されています。',
        MSG_0024: '建物名に不正な文字が入力されています。',
        MSG_0025: '取り外し作業を選択してください。',
        MSG_0026: '会社名・屋号を入力してください。',
        MSG_0027: '所属部署・役職を入力してください。',
        MSG_0028: '会社郵便番号を入力してください。',
        MSG_0029: '会社住所を入力してください。',
        MSG_0030: '従業員数を選択してください。',
        MSG_0031: '業種を選択してください。',
        MSG_0032: '電話番号を入力してください。',
        MSG_0033: '電話番号は半角数字10-11桁で入力してください。',
        MSG_0034: '会社郵便番号は半角数字のみで入力してください。',
        MSG_0035: 'ご入力いただいた情報のお申込はございません。',
        MSG_0036: '申込IDを入力してください。',
        MSG_0037: '以内の整数値を入力してください。',
        MSG_1001: '大型、中型、手のひらサイズいずれかの家電を入力してください。',
        MSG_1002: '中型、手のひらサイズいずれかの家電を入力してください。',
        MSG_1003: '大型、手のひらサイズいずれかの家電を入力してください。',
        MSG_1004: '大型サイズの家電を入力してください。',
        MSG_1005: '大型、中型サイズいずれかの家電を入力してください。',
        MSG_1006: '中型サイズの家電を入力してください。',
        MSG_9990: '中型料金マスタデータに不備があります。',
        MSG_9991: 'を選択してください。',
        MSG_9992: '回収対象の品目が存在しません。',
        MSG_9993: '不正な価格設定方法が設定されています。',
        MSG_9994: 'サイト情報が設定されていません。',
        MSG_9995: '翌日の回収をお受けできる時間を経過したため、',
        MSG_9996: '恐れ入りますが回収日時を再選択してください。',
        MSG_9997: '予期せぬエラーが発生しました。',
        MSG_9998: '入力内容にエラーがあります。',
        MSG_9999: '各項目のエラー内容をご確認ください。',
    },
    INFO: {
        MSG_0001: 'のダウンロードありがとうございました。',
        MSG_0002: 'またのご利用お待ちしております。',
        MSG_0003: '以下の情報を入力し、契約書のダウンロードを行ってください。',
        MSG_0004: '・申込完了メールに記載された「申込ID」',
        MSG_0005: '・申込時に入力した「メールアドレス」「電話番号」'
    }
}

export default {
    MESSAGES
}
